import React from 'react';
import {
  MessageCircle,
  ArrowRight,
  Bot,
  Settings,
  History,
  Lightbulb,
} from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const AIChatAssistant = () => {
  const chatFeatures = [
    {
      id: 'ask',
      title: 'Ask CAM360',
      description:
        'Get instant answers to your questions about contracts, assets, and business processes.',
      icon: <MessageCircle size={24} />,
      path: '/ai/chat-assistant/ask',
      color: 'bg-blue-50 text-blue-600',
    },
    {
      id: 'suggestions',
      title: 'Smart Suggestions',
      description:
        'Receive intelligent recommendations for contract improvements and asset optimization.',
      icon: <Lightbulb size={24} />,
      path: '/ai/chat-assistant/suggestions',
      color: 'bg-yellow-50 text-yellow-600',
    },
    {
      id: 'history',
      title: 'Chat History',
      description: 'Review your previous conversations and saved insights.',
      icon: <History size={24} />,
      path: '/ai/chat-assistant/history',
      color: 'bg-green-50 text-green-600',
    },
    {
      id: 'settings',
      title: 'Settings',
      description: 'Customize your AI assistant preferences and behavior.',
      icon: <Settings size={24} />,
      path: '/ai/chat-assistant/settings',
      color: 'bg-gray-50 text-gray-600',
    },
  ];

  return (
    <>
      {/* Breadcrumb - Outside page-container to align with sidebar */}
      <PageBreadcrumb />
      {/* Page Header - Outside page-container to align with sidebar */}
      <PageHeader
        title="AI Chat Assistant"
        description="Your intelligent assistant for Contract LifeCycle Management. Get instant answers, smart suggestions, and expert guidance powered by advanced AI."
      />
      <div className="page-container">
        {/* AI Assistant Features Cards - Matching OverviewLanding spacing */}
        <div
          className="grid-modern-4"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            width: '100%',
          }}
        >
          {chatFeatures.map((feature) => (
            <div
              key={feature.id}
              className="asset-landing-card"
              onClick={() => (window.location.href = feature.path)}
            >
              {/* Top Accent Line */}
              <div
                style={{
                  height: '4px',
                  background: `var(--primary-color)`,
                  width: '100%',
                }}
              />

              {/* Card Content */}
              <div style={{ padding: '24px' }}>
                {/* Icon and Title */}
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '10px',
                      background: '#D6EFFF',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                    }}
                  >
                    <div
                      style={{ color: '#2D7DD2' }}
                      className="asset-card-icon"
                    >
                      {feature.icon}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h4
                      style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: 'var(--text-primary)',
                        margin: '0',
                        fontFamily: 'var(--font-family)',
                      }}
                    >
                      {feature.title}
                    </h4>
                  </div>
                  <ArrowRight size={20} className="asset-card-arrow" />
                </div>

                {/* Description */}
                <p
                  style={{
                    fontSize: '14px',
                    color: 'var(--text-secondary)',
                    margin: '0 0 16px 0',
                    lineHeight: '1.5',
                    fontFamily: 'var(--font-family)',
                  }}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AIChatAssistant;